/** Shown when the staff list could not be loaded at all. */
export default function UsersErrorState({ message }: { message: string }) {
  return (
    <div className="bg-clay-50 dark:bg-clay-900/20 border border-clay-200 dark:border-clay-800 text-clay-700 dark:text-clay-300 rounded-lg p-4 text-sm">
      Couldn&apos;t load users: {message}
    </div>
  );
}
